__webpack_require__.p = "https://todaysgolfer-assets.bauersecure.com/js/";